<div class="card" [ngClass]="'card-'+feel">
	<div class="card-header">
		<ng-content select="[header]"></ng-content>
	</div>
	<div class="card-body">
		<ng-content select="[body]"></ng-content>
	</div>
	<div class="card-footer" *ngIf="showFooter">
		<ng-content select="[footer]"></ng-content>
	</div>
</div>